
import Austria from './austria.png';
import England from './england.png';
import Hungary from './hungary.png';
import Serbia from './serbia.png';
import Slovenia from './slovenia.png';
import Turkey from './turkey.png';

export { Austria, England, Hungary, Serbia, Slovenia, Turkey };
